<template>
  <v-card class="pa-6" elevation="0" outlined>
    <v-card-text class="">
      <p class="text-subtitle-1 ma-0 text-center black--text">Choose your industry and define terminologies. </p>
      <p class="text-caption ma-0 text-center text-light">
        Please change according to your organization's needs
      </p>
    </v-card-text>


    <v-card-text elevation="0" class="">
      <v-select label="Industry" outlined v-model="account.industry" :items="terminologyData.terms" item-value="code"
        item-text="IndustryName" @change="updateTermsSet" hide-details />
    </v-card-text>

    <v-card-text elevation="0" class="pt-0">


      <v-card class="mx-auto" elevation="0" tile outlined>
        <v-card-text class="text-center text-overline text--secondary">Select or Edit the terms that fits to your
          organization</v-card-text>

        <template v-for="(item) in accountTerminologyList">

          <v-list-item three-line :key="item.id">
            <v-list-item-content>
              <v-list-item-title>
                <!-- {{ item.name }} -->
                <v-combobox hide-details v-model="item.value" outlined :rules="requiredRules" dense
                  :items="item.options"></v-combobox>

              </v-list-item-title>

              <v-list-item-subtitle class="text-caption pt-4 text--secondary">
                {{ item.description }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-card>
    </v-card-text>

    <v-card-text elevation="0" class="text-center">
      <v-btn rounded :block="isBlockButton" x-large color="primary" @click="saveTerm()">
        Save & Continue
      </v-btn>

    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
import terminologyData from '@/assets/data/terminology.json'

export default {
  name: "TerminologyForm",
  props: {
    account: {
      type: Object,
      required: true
    },
    isBlockButton: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      accountTerminologyList: [],
      termHeaders: [
        {
          text: "Value",
          value: "value",
          align: "start",
          sortable: false,
          width: 180
        },
        {
          text: "Description",
          value: "description",
          align: "start",
          sortable: false
        },
      ],
      terminologyData,
      accountIndustry: null
    };
  },
  created() {
    this.getTerminologies();
  },
  watch: {
    // 'account.industry': function () {
    //   this.updateTermsSet();
    // }
  },
  methods: {
    ...mapActions("messages", ["addErrorMessage", "addSuccessMessage"]),
    ...mapActions("accountTerminology", ["fetchAccountTerminologies"]),

    updateTermsSet() {
      const selectedIndustry = this.terminologyData.terms.filter(item => item.code == this.account.industry);

      this.accountTerminologyList.forEach((item) => {
        if (item.name.toLowerCase() == "rp") {
          item.value = selectedIndustry[0].rp.name;
          item.options = selectedIndustry[0].rp.options;
        }
        else if (item.name.toLowerCase() == "student") {
          item.value = selectedIndustry[0].student.name
          item.options = selectedIndustry[0].student.options
        }
        else if (item.name.toLowerCase() == "classroom") {
          item.value = selectedIndustry[0].classroom.name
          item.options = selectedIndustry[0].classroom.options
        }
        else if (item.name.toLowerCase() == "center") {
          item.value = selectedIndustry[0].center.name
          item.options = selectedIndustry[0].center.options
        }
        else if (item.name.toLowerCase() == "enrollment") {
          item.value = selectedIndustry[0].enrollment.name
          item.options = selectedIndustry[0].enrollment.options
        }
        else {
          item.value = selectedIndustry[0].tuition.name
          item.options = selectedIndustry[0].tuition.options
        }
      })
    },
    getTerminologies() {
      this.fetchAccountTerminologies()
        .then(response => {
          if (response) {
            this.accountTerminologyList = response.content;
            this.accountTerminologyList.forEach((item) => {
              if (item.name.toLowerCase() == "rp") { item.description = terminologyData.termDescription[0].rp }
              else if (item.name.toLowerCase() == "student") { item.description = terminologyData.termDescription[0].student }
              else if (item.name.toLowerCase() == "classroom") { item.description = terminologyData.termDescription[0].classroom }
              else if (item.name.toLowerCase() == "center") { item.description = terminologyData.termDescription[0].center }
              else if (item.name.toLowerCase() == "enrollment") { item.description = terminologyData.termDescription[0].enrollment }
              else if (item.name.toLowerCase() == "teacher") { item.description = terminologyData.termDescription[0].teacher }
              else if (item.name.toLowerCase() == "program") { item.description = terminologyData.termDescription[0].program }
              else { item.description = terminologyData.termDescription[0].tuition }
              item.oldValue = item.value;
            })
          }
        })
        .catch(error => {
          this.addErrorMessage("Server response with error " + error);
        });
    },

    async saveTerm() {
      this.updateAccountIndustry()

      this.accountTerminologyList.forEach((item) => {
        //process save only on the items that changed
        if (String(item.oldValue).toLowerCase() != String(item.value).toLowerCase()) {

          const firstLetter = item.value.charAt(0)
          const firstLetterCap = firstLetter.toUpperCase()
          const remainingLetters = item.value.slice(1)
          const valueCapitalized = firstLetterCap + remainingLetters

          const terminologyListTemp = { id: item.id, accountId: item.accountId, name: item.name, value: valueCapitalized }

          this.updateTermAsync(terminologyListTemp);

        }
      })
      this.addSuccessMessage("Terminologies Updated");
      this.$emit("continueNext");
    },
    async updateTermAsync(terms) {
      const savedTerms = await this.updateTerminology(terms);
      if (savedTerms) {
        console.log(savedTerms)
      }
    },
    async updateTerminology(termSet) {
      return await this.$axios
        .post("/account/terminology/update", termSet)
        .then((resp) => {
          const updatedTerms =
            resp.data && resp.data.data ? resp.data.data : null;
          return updatedTerms;
        })
        .catch((error) => {
          this.addErrorMessage("Server response with error " + error);
        });
    },
    updateAccountIndustry() {
      const data = Object.assign({}, this.account);
      data.logo = null;
      data.admins = null;
      data.locations = null;
      data.accountTerminologies = null;
      data.admins = null;
      data.profileMappingSet = null;

      this.$axios
        .post("/account/info", data)
        .then(() => {
          console.log("updated account");
        })
        .catch(error => {
          this.addErrorMessage(error.message);
        });
    }
  }
};
</script>
<style>
#termTable .v-data-table__mobile-row__header {
  display: none;
}

#termTable .v-data-table__mobile-row__cell {
  text-align: left !important;
  width: 100%;
}

#termTable tr.v-data-table__mobile-table-row {
  padding: 10px 0;
}

#termTable .v-data-table-header {
  background-color: #3f51b5 !important;
}

#termTable .v-data-table-header span {
  color: #FFF;
}
</style>